// do not display these columns ...yet
export const PLAY_FINDER_COLUMNS_BLACKLIST = [
  'playerRoleF',
  'playerRoleH',
  'playerRoleX',
  'playerRoleY',
  'playerRoleZ',
];
